import { CryptoLocalStorage } from "zoox-infra";
import BaseService from "./base-service";

export default class CompanyService extends BaseService {
  getOne(id) {
    return this.getWithCache(`open/company/${id}`);
  }

  getBySubdomain(subdomain) {
    return this.apiClient.get(`open/company/subdomain/${subdomain}`);
  }

  setLocalCompany(company) {
    if (company && company.id) {
      localStorage.setItem("currentCompany", JSON.stringify(company));
    }
  }

  setGroupOrCompany(company) {
    CryptoLocalStorage.setItem(
      "group_or_company",
      JSON.stringify({ type: "company", id: company.id })
    );
  }

  getLocalCompany() {
    const company = localStorage.getItem("currentCompany");

    if (company && company != "undefined" && company != "null") {
      return JSON.parse(company);
    }

    return {};
  }

  getCurrentCompany() {
    return this.getLocalCompany();
  }

  getFnrhMessageSettings(id) {
    return this.getWithCache(`open/company/${id}/product/fnrhmessage`);
  }

  getFnrhFormSettings(id) {
    return this.getWithCache(`open/company/${id}/product/fnrhform`);
  }

  getCustomizationSettings(subdomain) {
    return this.getWithCache(`open/company/${subdomain}/customization`);
  }

  getLogo(id) {
    return this.getWithCache(`open/company/${id}/product/logo`);
  }

  setLocalCustomizationSettings(settings) {
    localStorage.setItem("customizationSettings", JSON.stringify(settings));
  }

  getLocalCustomizationSettings() {
    const settings = localStorage.getItem("customizationSettings");

    if (settings && settings != "undefined" && settings != "null") {
      return JSON.parse(settings);
    }
    return {};
  }

  getFieldSettings(companyId) {
    return this.getWithCache(`open/field-settings/${companyId}/`);
  }
}
